export default __webpack_public_path__ + "static/media/drop-off-pin.67f23fbe.svg";